var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppAnimate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#00005B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4266 33.5277H12.9901L11.2371 38.9329C11.164 39.152 11.0179 39.2251 10.7988 39.2251H6.56228C6.30663 39.2251 6.23359 39.1155 6.30663 38.8598L13.611 17.7868C13.7571 17.4216 13.9032 16.9833 13.9397 15.5955C13.9397 15.4129 14.0492 15.3398 14.1953 15.3398H20.0023C20.1849 15.3398 20.2579 15.3764 20.2945 15.5225L28.6214 38.8964C28.6945 39.1155 28.6579 39.2251 28.4023 39.2251H23.6545C23.4719 39.2251 23.3623 39.152 23.2527 39.0059L21.4266 33.5277ZM14.3049 28.999H20.0388C19.3449 26.5885 17.884 22.1694 17.1536 19.5398H17.1171C16.5327 22.0233 15.2545 26.0407 14.3049 28.999Z",
    fill: "#9999FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.33 38.8964V25.3468C31.33 24.1051 31.257 22.2059 31.1839 21.4025C31.1839 21.1833 31.2205 21.1103 31.4396 21.1103H35.2744C35.5665 21.1103 35.7126 21.1833 35.7857 21.4025C35.9318 21.6946 36.0048 22.0964 36.0778 22.5711C37.6118 21.3659 39.3283 20.7451 41.2274 20.7451C44.0396 20.7451 47.3996 22.2059 47.3996 28.0494V38.8964C47.3996 39.152 47.29 39.2251 47.0709 39.2251H42.6518C42.4326 39.2251 42.2865 39.152 42.2865 38.8964V28.5242C42.2865 26.2964 41.3735 25.1277 39.4744 25.1277C38.2326 25.1277 37.1735 25.5659 36.4065 26.2964V38.9329C36.4065 39.152 36.297 39.2251 36.1144 39.2251H31.6587C31.4396 39.2251 31.33 39.152 31.33 38.8964Z",
    fill: "#9999FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppAnimate);
export default __webpack_public_path__ + "static/media/B_app_Animate.1addb5e556a1bf83dd01efea24883dc0.svg";
export { ForwardRef as ReactComponent };